import { Box, List, styled } from '@mui/material';

export const WorkspacesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: 'inherit',
  maxHeight: 'inherit',
  overflowY: 'scroll'
}));

export const TopWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 1.8, 1.6, 1.8)
}));

export const StyledListButton = styled(List)(({ theme }) => ({
  padding: theme.spacing(2.6, 0, 0, 0),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.6)
}));

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: theme.spacing(1.4)
}));

export const HeaderLeftContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

export const WorkspaceItemWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
}));

export const FooterWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  height: 'fit-content',
  borderTop: `1px solid ${theme.colors.alpha.black[10]}`,
  gap: theme.spacing(2),
  padding: theme.spacing(4, 1.6, 3, 1.6),
  marginTop: theme.spacing(2),

  '.MuiListItem-root': {
    padding: 0,

    '.MuiButton-root': {
      display: 'flex',
      color: theme.inferiorMenu.menuItemColor,
      backgroundColor: theme.inferiorMenu.menuItemBg,
      width: '100%',
      borderRadius: 0,
      justifyContent: 'flex-start',
      padding: 0,

      '.MuiTypography-root': {
        fontWeight: 900
      },

      '.MuiButton-startIcon': {
        fontSize: theme.typography.pxToRem(20),
        color: theme.inferiorMenu.menuItemIconColor,

        '&.Mui-active, &:hover': {
          backgroundColor: theme.inferiorMenu.menuItemBgActive,
          color: theme.inferiorMenu.menuItemColorActive,

          '.MuiButton-startIcon': {
            color: theme.inferiorMenu.menuItemIconColorActive
          }
        }
      }
    }
  }
}));

export const CreateWorkspaceWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center'
}));
